import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import Service from "@/services/ObservasiKebidananBishop";
import { ObservasiKebidananBishop } from "@/types/ObservasiKebidananBishop";

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "observasi-kebidanan-bishop"
})
class ObservasiKebidananBishopStoreModule extends VuexModule {
  loading = false;
  current: ObservasiKebidananBishop | null = null;
  isAnyUnsavedChange = false;

  @Mutation
  SET_CURRENT(val: ObservasiKebidananBishop | null) {
    this.current = val;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation
  SET_IS_ANY_UNSAVED_CHANGE(val: boolean) {
    this.isAnyUnsavedChange = val;
  }

  @Mutation
  RESET_STORE() {
    this.current = null;
    this.isAnyUnsavedChange = false;
    this.loading = false;
  }

  @Action({ rawError: true })
  async loadByRegister(registerId: string | number): Promise<void> {
    this.SET_LOADING(true);
    const response = await Service.getByRegister(registerId).finally(() => {
      this.SET_LOADING(false);
    });
    this.SET_CURRENT(response?.data ?? null);
  }

  @Action({ rawError: true })
  async save(
    payload: Partial<ObservasiKebidananBishop> & Record<string, any>
  ): Promise<ObservasiKebidananBishop | null> {
    this.SET_LOADING(true);
    const currentId = this.current?.id;
    const request =
      currentId != null
        ? Service.update(currentId, payload)
        : Service.create(payload);
    const response = await request.finally(() => {
      this.SET_LOADING(false);
    });
    const saved = response?.data ?? null;
    this.SET_CURRENT(saved);
    this.SET_IS_ANY_UNSAVED_CHANGE(false);
    return saved;
  }

  @Action({ rawError: true })
  async signBidan(data: any = {}): Promise<void> {
    const currentId = this.current?.id;
    if (currentId == null) return;
    this.SET_LOADING(true);
    await Service.signBidan(currentId, data).finally(() => {
      this.SET_LOADING(false);
    });
    const reloaded = await Service.find(currentId);
    this.SET_CURRENT(reloaded?.data ?? null);
  }

  @Action({ rawError: true })
  async signKoordinator(data: any = {}): Promise<void> {
    const currentId = this.current?.id;
    if (currentId == null) return;
    this.SET_LOADING(true);
    await Service.signKoordinator(currentId, data).finally(() => {
      this.SET_LOADING(false);
    });
    const reloaded = await Service.find(currentId);
    this.SET_CURRENT(reloaded?.data ?? null);
  }

  @Action({ rawError: true })
  async signDpjp(data: any = {}): Promise<void> {
    const currentId = this.current?.id;
    if (currentId == null) return;
    this.SET_LOADING(true);
    await Service.signDpjp(currentId, data).finally(() => {
      this.SET_LOADING(false);
    });
    const reloaded = await Service.find(currentId);
    this.SET_CURRENT(reloaded?.data ?? null);
  }

  @Action({ rawError: true })
  setIsAnyUnsavedChange(val: boolean): void {
    this.SET_IS_ANY_UNSAVED_CHANGE(val);
  }

  @Action({ rawError: true })
  reset(): void {
    this.RESET_STORE();
  }
}

export default getModule(ObservasiKebidananBishopStoreModule);
